// eslint-disable-next-line import/prefer-default-export
export const getComputedCSSVariable = (varName: string) => getComputedStyle(document.documentElement).getPropertyValue(`--${varName}`);
